import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import { useForm } from "../../useForm";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { FormsRef } from "../../formsRef";

const initialFValues = {
  id: 0,
  title: "",
  titleENG: "",
  link: "",
  align: "",
};

const MediaForm = (props) => {
  const { upload, showModal, handleClose, pageTitle, carry, files } = props;
  const { title, titleENG, link, align } = FormsRef();

  const { values, setValues, handleInputChange, resetForm } =
    useForm(initialFValues);

  const handleSubmit = (e) => {
    e.preventDefault();
    upload({
      id: carry.id,
      title: title.current.value,
      titleENG: titleENG.current.value,
      align: align.current.value,
      link: link.current.value,
    });
  };

  return (
    <Modal show={showModal} onHide={handleClose} size="lg">
      <Modal.Header>
        <Modal.Title>{pageTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control ref={title} defaultValue={carry.title || ""} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Link</Form.Label>
                <Form.Control ref={link} defaultValue={carry.link || ""} />
              </Form.Group>
            </Grid>
            <Grid item xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>TitleENG</Form.Label>
                <Form.Control
                  ref={titleENG}
                  defaultValue={carry.titleENG || ""}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Align</Form.Label>
                <Form.Control ref={align} defaultValue={carry.align || ""} />
              </Form.Group>
            </Grid>
          </Grid>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Bezárás
        </Button>
        <Button variant="primary" onClick={handleSubmit} type="submit">
          Mentés
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MediaForm;
